import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/products/freepik_cinematic-close-up-of-a-m_2857207265.png")